import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { GetUserBlance, updateUserBalance } from "./userbal";
import { loginSuccess } from "./auth";
import { CreatePlayload } from "../../lib/token";

const allModals = JSON.parse(localStorage.getItem("bonus_modals")) || {
  pending: [],
  completed: [],
};
export const completedModals = allModals.completed;
const pendingModals = allModals.pending;
const initialState = {
  modals: pendingModals,
  openModal: pendingModals.length ? pendingModals[0] : null,
  interacting: null,
  available: [],
  loading: false,
  error: null,
};

const GiftCampaigns = createSlice({
  name: "giftbal",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    closePermanent: (state) => {
      state.loading = false;
      state.openModal = null;
      let removed;
      if (state.modals.includes(state.interacting)) {
        removed = state.modals.shift();
      }
      state.interacting = null;
      if (removed) {
        completedModals.push(removed);
      }
      localStorage.setItem(
        "bonus_modals",
        JSON.stringify({
          pending: state.modals,
          completed: completedModals,
        })
      );
    },
    addBonusModal: (state, action) => {
      if (!state.modals.includes(action.payload)) {
        state.modals.push(action.payload);
        localStorage.setItem(
          "bonus_modals",
          JSON.stringify({
            pending: state.modals,
            completed: completedModals,
          })
        );
        if (!state.openModal) {
          state.openModal = state.modals[0];
        }
      }
    },
    openNextModal: (state, action) => {
      if (state.modals.length && !state.interacting) {
        state.openModal = state.modals[0];
      }
    },
    closeTemporary: (state, action) => {
      if (state.modals.includes(state.openModal)) {
        state.modals.shift();
      }
      state.openModal = null;
    },
    setRewards: (state, action) => {
      state.available = action.payload;
    },
    updateReward: (state, action) => {
      const index = state.available.findIndex(
        (item) => item._id === action.payload._id
      );
      if (index !== -1) {
        state.available[index] = action.payload;
      }
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setInteracting: (state, action) => {
      state.interacting = action.payload;
    },
  },
});

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
// Actions
export const {
  requestStart,
  closePermanent,
  requestFailure,
  addBonusModal,
  closeTemporary,
  openNextModal,
  setInteracting,
  setRewards,
  updateReward,
} = GiftCampaigns.actions;

export const availSuccess = () => (dispatch) => {
  dispatch(closePermanent());
  setTimeout(() => {
    dispatch(openNextModal());
  }, 1000);
};

export const closeBonusModal = () => (dispatch) => {
  dispatch(closeTemporary());
  setTimeout(() => {
    dispatch(openNextModal());
  }, 1000);
};

export const SignupGiftAvail = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    dispatch(setInteracting("signup"));
    const response = await axios.post(`/private/gift/${makeid(50)}`, data);
    dispatch(GetUserBlance(data));
    if (response.status === 200) {
      const Token = CreatePlayload(CreatePlayload(response?.data?.user));
      localStorage.setItem("logged", Token?.token);
      const user = response?.data;
      dispatch(availSuccess(response.data));
      dispatch(loginSuccess(user));
    }
  } catch (err) {
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
    dispatch(closeBonusModal());
  }
};

export const GetAvailableGifts = () => async (dispatch) => {
  try {
    const response = await axios.get(`/private/rewards`);
    if (response.status !== 200) {
      throw new Error("Fetching rewards failed");
    }
    dispatch(setRewards(response.data));
  } catch (error) {
    console.log(error.data);
  }
};

export const ClaimSpinReward = (data) => async (dispatch) => {
  try {
    const response = await axios.post(`/private/rewards`, data);
    if (response.status !== 200) {
      throw new Error("Fetching rewards failed");
    }
    const { reward, newBalance } = response.data;
    dispatch(updateReward(reward));
    dispatch(updateUserBalance(newBalance));
    toast.success("Reward claimed successfully");
    return true;
  } catch (error) {
    console.log(error.data);
    toast.success("Claiming reward failed");
    return false;
  }
};

export default GiftCampaigns.reducer;
